'use strict';

angular.module('esn.calendar')
  .component('calCalendarSharedConfiguration', {
    template: require('./calendar-shared-configuration.pug'),
    controller: 'CalCalendarSharedConfigurationController'
  });
